import type { PickStateRefValues } from '@wix/editor-elements-integrations';
import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type { IHamburgerMenuContainerProps } from '../HamburgerMenuContainer.props';

export default withCompController<
  IHamburgerMenuContainerProps,
  {},
  IHamburgerMenuContainerProps,
  PickStateRefValues<'experiments'>
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;
  const isOverflowFixEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.HamburgerMenuOverflowFix',
  );

  return {
    ...mapperProps,
    isOverflowFixEnabled,
  };
});
